import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL


class ApiService {
    getAuthConfig() {
        const token = localStorage.getItem('token')
        if (!token) {
            return {}
        }
        return {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    }
    async hasAuth(data) {
        const url = `${API_URL}/check_auth/`;
        return axios.post(url, data).then(response => response.data)
    }
    login(data) {
        const url = `${API_URL}/login/`;
        return axios.post(url, data).then(response => response.data)
    }
    logout(data) {
        const url = `${API_URL}/logout/`;
        return axios.post(url, data).then(response => response.data)
    }
    signUp(data) {
        const url = `${API_URL}/create_user/`;
        return axios.post(url, data).then(response => response.data)
    }
    getUser(data) {
        const url = `${API_URL}/get_user/`;
        return axios.post(url, data).then(response => response.data)
    }
    deleteUser(data) {
        const url = `${API_URL}/delete_user/`;
        return axios.post(url, data).then(response => response.data)
    }
    getMessages() {
        const url = `${API_URL}/api/alira/messages/`;
        return axios.get(url).then(response => response.data);
    }
    getPosts() {
        const url = `${API_URL}/api/alira/blog/`;
        return axios.get(url).then(response => response.data);
    }
    getPost(pk) {
        const url = `${API_URL}/api/alira/blog/${pk}`;
        return axios.get(url).then(response => response.data);
    }
    getImage(img) {
        const url = `${API_URL}/api/alira/images/${img}`;
        return axios.get(url).then(response => response.data);
    }
    createTranscription(data) {
        const url = `${API_URL}/access/transcriptions/create/`
        return axios.post(url, data, this.getAuthConfig()).then(response => response.data)
    }
    listTranscriptions() {
        const url = `${API_URL}/access/transcriptions/`
        return axios.get(url, this.getAuthConfig()).then(response => response.data)
    }
    getTranscription(transcriptionId) {
        const url = `${API_URL}/access/transcriptions/${transcriptionId}/`
        return axios.get(url, this.getAuthConfig()).then(response => response.data)
    }
    downloadTranscription(transcriptionId, type = 'transcription') {
        const url = `${API_URL}/access/transcriptions/${transcriptionId}/download/?type=${type}`
        return axios.get(url, {
            ...this.getAuthConfig(),
            responseType: 'blob',
        }).then(response => response.data)
    }
    deleteTranscription(transcriptionId) {
        const url = `${API_URL}/access/transcriptions/${transcriptionId}/delete/`
        return axios.delete(url, this.getAuthConfig()).then(response => response.data)
    }
    createSubscriber(data) {
        const url = `${API_URL}/api/alira/subscriber/`;
        return axios.post(url, data).then(response => response.data);
    }
    recoverPassword(data) {
        const url = `${API_URL}/recoverpassword/`;
        return axios.post(url, data).then(response => response.data);
    }
    validatePayment(data) {
        const  url = `${API_URL}/validate-payment/`
        return axios.post(url, data).then(response => response.data)
    }
    validatePasswordToken(data) {
        const  url = `${API_URL}/validate-password-token/`
        return axios.post(url, data).then(response => response.data)
    }
    changeEmail(data) {
        const  url = `${API_URL}/changeemail/`
        return axios.post(url, data).then(response => response.data)
    }
    changePassword(data) {
        const  url = `${API_URL}/changepassword/`
        return axios.post(url, data).then(response => response.data)
    }
    contact(data) {
        const  url = `${API_URL}/contact/`
        return axios.post(url, data).then(response => response.data)
    }
    deleteSubscription(data) {
        const  url = `${API_URL}/deletesubscription/`
        return axios.post(url, data).then(response => response.data)
    }
}

export default ApiService;